import PropTypes from 'prop-types';
import React from 'react';
import { Input } from 'rebass';

import config from 'frontend/config';

class BlurUpdateInput extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  };

  static defaultProps = {
    value: null,
  };

  state = {
    input: this.props.value,
    lastValue: this.props.value,
  };

  static getDerivedStateFromProps(props, state) {
    // if props have changed, reset internal state
    if (props.value !== state.lastValue) {
      return {
        input: props.value,
        lastValue: props.value,
      };
    }

    return null;
  }

  render() {
    const { onChange, ...props } = this.props;
    return (
      <Input
        autoComplete="off"
        color={config.color}
        backgroundColor={config.colors.primary}

        {...props}

        onBlur={onChange} // Fire onChange from callee when input is blurred
        onChange={e => this.setState({ input: e.target.value })}
        value={this.state.input}
      />
    );
  }
}

export default BlurUpdateInput;
